import React from 'react';
import { Navigate } from 'react-router-dom';

// A protected route that redirects to login if no valid token found
export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
